import { IEvent } from '.';
import { DataHelper } from '../../utils/data-helper';

export interface IAppointmentForUpdatingMultiResourceModel {
  AppointmentId?: number;
  IsOnlyUser?: boolean;
  NewEndTime?: string;
  NewStartTime?: string;
  NewUserId?: number;
}
export class AppointmentForUpdatingMultiResourceModel implements IAppointmentForUpdatingMultiResourceModel {
  AppointmentId?: number;
  IsOnlyUser?: boolean;
  NewEndTime?: string;
  NewStartTime?: string;
  NewUserId?: number;
  /**
   *
   */
  constructor(resourceId: string, event: IEvent, isOnly?: boolean) {
    this.AppointmentId = event.originId;
    this.IsOnlyUser = isOnly || false;
    this.NewStartTime = DataHelper.formatDateTime(event.start);
    this.NewEndTime = DataHelper.formatDateTime(event.end);
    this.NewUserId = parseInt(resourceId);
  }
}